module.exports = __webpack_public_path__ + "img/CH2NH_Structures.8edc7bca.png";